import { WidgetCard } from '@/components/common/WidgetCard';
import { UsageGauge } from '@/components/common/UsageGauge';
import { useStats } from '@/features/dashboard/hooks/useDashboard';
import { formatBytes } from '@/lib/format';
import { ChartPieIcon } from '@/icons';

/** Storage usage gauge — used vs quota, from mail-admin /statistics. */
export function StorageWidget() {
  const { data, isLoading, isError, refetch } = useStats();
  const percent = data && data.storageQuotaBytes > 0
    ? (data.storageUsedBytes / data.storageQuotaBytes) * 100
    : 0;
  return (
    <WidgetCard title="Storage" icon={ChartPieIcon} isLoading={isLoading} isError={isError} onRetry={refetch}>
      {data && (
        <UsageGauge
          percent={percent}
          label="Storage used"
          caption={`${formatBytes(data.storageUsedBytes)} of ${formatBytes(data.storageQuotaBytes)}`}
        />
      )}
    </WidgetCard>
  );
}
